import ImageLib, { ImageProps as NextImageProps } from 'next/legacy/image';
import FutureImageLib, { ImageProps as FutureNextImageProps } from 'next/image';
import { prepareImageDescription } from '@packages/shared/core/common/utils/images';

export type ImageProps = ({ type?: 'default' } & NextImageProps) | ({ type?: 'future' } & FutureNextImageProps);

const isFutureImage = (type: ImageProps['type'], image: ImageProps): image is FutureNextImageProps => type === 'future';

const Image = (props: ImageProps) => {
  const { type = 'default', alt = null } = props;

  const extendedProps = { ...props, ...prepareImageDescription(alt) };

  if (isFutureImage(type, extendedProps)) return <FutureImageLib {...extendedProps} />;

  return <ImageLib {...extendedProps} />;
};

export default Image;
